<!-- //
个人信息
@auth xuyd
@date 2023-3-18
//-->
<template>
  <page-layout layout="C">
    <div class="layout-result">
      <el-form @submit.native.prevent ref="refForm" :model="form" size="small" label-width="100px" class="layout-form">
        <el-form-item prop="username" label="账号">
          <span>{{ userSession.username }}</span>
        </el-form-item>
        <el-form-item prop="nickName" label="姓名">
          <span>{{ userSession.nickName }}</span>
        </el-form-item>
        <el-form-item prop="phoneNumber" label="手机号">
          <span>{{ userSession.phoneNumber }}</span>
        </el-form-item>
        <el-form-item prop="email" label="邮箱">
          <span>{{ userSession.email }}</span>
        </el-form-item>
        <el-form-item prop="avatar" label="头像">
          <img :src="userSession.avatar" class="user-avatar">
        </el-form-item>
      </el-form>
    </div>
  </page-layout>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'UserProfile',
  data() {
    return {
      form: {},
    }
  },
  computed: {
    ...mapGetters([
      'userSession',
    ]),
  },
}
</script>

<style lang="less" scoped>
.layout-form {
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

}
</style>

